import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";

const features = [
  {
    title: "Live & Always Updated and Shareable",
    description: "Send a single link instead of multiple PDFs. Your Mission Hub microsite makes sharing easy and professional.",
    image: "/images/solutions/mission-hub/live-updates.jpg",
    bullets: [
      "One link for all your opportunities,corporate & community.",
      "Real-time event updates,no outdated listings.",
      "Custom branding to reflect your nonprofit’s identity.",
      "Mobile-friendly and optimized for easy access."
      
    ]
  },
  {
    title: "Seamless Integration & Customization",
    description: "Works seamlessly with AI Assistant and Knowledge Hub while allowing nonprofits to customize visibility settings.",
    image: "/images/solutions/mission-hub/integration.jpg",
    bullets: [
      "AI Assistant answers visitor questions instantly.",
      "Knowledge Hub provides context-aware insights.",
      "Control which sections of Mission Hub are visible."
    ]
  },
];

export const MissionHubPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F2FCE2] to-white">
      {/* Hero Section */}
      <div className="relative overflow-hidden bg-[#2D7D46] text-white py-20">
        <div className="absolute inset-0 bg-[url('/images/hero-pattern.svg')] opacity-10" />
        <div className="container mx-auto px-4 relative">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl font-bold mb-5">Mission Hub</h1>
            <p className="text-xl md:text-2xl text-gray-100 mb-6">
              Your Opportunities, Always Up-to-Date & Bookable
            </p>
            <p className="text-lg text-gray-200">
              No more scattered PDFs, outdated decks, or back-and-forth emails. Instantly shareable, effortlessly bookable by corporate partners and community volunteers alike.
            </p>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="container mx-auto px-4 py-16">
        {features.map((feature, index) => (
          <div 
            key={feature.title}
            className={`flex flex-col md:flex-row items-center gap-12 py-16 ${
              index % 2 === 1 ? 'md:flex-row-reverse' : ''
            }`}
          >
            <div className="flex-1">
              <h2 className="text-2xl md:text-3xl font-bold mb-4">{feature.title}</h2>
              <p className="text-gray-600 mb-6">{feature.description}</p>
              <ul className="space-y-3">
                {feature.bullets.map((bullet, i) => (
                  <li key={i} className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-[#2D7D46]" />
                    <span className="text-gray-700">{bullet}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex-1">
              <img
                src={feature.image}
                alt={feature.title}
                className="rounded-lg shadow-lg w-full"
              />
            </div>
          </div>
        ))}
      </div>

      {/* CTA Section */}
      <div className="bg-[#2D7D46] text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to Transform Your Nonprofit’s Event Management?
          </h2>
          <p className="text-xl mb-8">
            Get started with Mission Hub today and make event planning effortless.
          </p>
          <Button
            size="lg"
            className="bg-white text-[#2D7D46] hover:bg-gray-100"
            onClick={() => navigate('/signup')}
          >
            Get Started Now
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MissionHubPage;
